var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c("div", { staticClass: "input-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.invoice.discount,
              expression: "invoice.discount",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "number", placeholder: "Скидка" },
          domProps: { value: _vm.invoice.discount },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.invoice, "discount", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "custom-control custom-radio" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.invoice.discount_type,
              expression: "invoice.discount_type",
            },
          ],
          staticClass: "custom-control-input",
          attrs: { type: "radio", id: "r1", value: "2" },
          domProps: { checked: _vm._q(_vm.invoice.discount_type, "2") },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.invoice, "discount_type", "2")
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "custom-control-label", attrs: { for: "r1" } },
          [_vm._v("Общая сумма в валюте накладной")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "custom-control custom-radio" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.invoice.discount_type,
              expression: "invoice.discount_type",
            },
          ],
          staticClass: "custom-control-input",
          attrs: { type: "radio", id: "r2", value: "1" },
          domProps: { checked: _vm._q(_vm.invoice.discount_type, "1") },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.invoice, "discount_type", "1")
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "custom-control-label", attrs: { for: "r2" } },
          [_vm._v("Процент с каждой позиции")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "" } }, [_vm._v("Дополнительные расходы")]),
      _vm._v(" "),
      _c("div", { staticClass: "input-group" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.invoice.extra_settings.expenses_by_price,
              expression: "invoice.extra_settings.expenses_by_price",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "number", placeholder: "Расход" },
          domProps: { value: _vm.invoice.extra_settings.expenses_by_price },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.invoice.extra_settings,
                "expenses_by_price",
                $event.target.value
              )
            },
          },
        }),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.invoice.extra_settings.expenses_by_qty,
              expression: "invoice.extra_settings.expenses_by_qty",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "number", placeholder: "Расход" },
          domProps: { value: _vm.invoice.extra_settings.expenses_by_qty },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.invoice.extra_settings,
                "expenses_by_qty",
                $event.target.value
              )
            },
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("По стоимости")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("По упаковкам")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }